module.exports = __webpack_public_path__ + "media/images/redrock/faq-7b6975a3599bb8481ebf635d3e6c2295.jpg";